module.exports = __webpack_public_path__ + "img/news5.0af05797.jpg";